import {ApplicationRef, createComponent, EnvironmentInjector, Injectable} from '@angular/core';
import {DialogComponent, DialogConfig} from '../components/dialog/dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private dialogComponentRef?: any;

  constructor(
    private appRef: ApplicationRef,
    private injector: EnvironmentInjector
  ) {
  }

  alert(message: string, title: string = 'Alert', confirmText: string = 'OK'): Promise<void> {
    return this.show({type: 'alert', title, message, confirmText}).then(() => undefined);
  }

  confirm(message: string, title: string = 'Confirm', confirmText: string = 'Confirm', cancelText: string = 'Cancel'): Promise<boolean> {
    return this.show({type: 'confirm', title, message, confirmText, cancelText});
  }

  private show(config: DialogConfig): Promise<boolean> {
    // Create the component if it doesn't exist
    if (!this.dialogComponentRef) {
      this.dialogComponentRef = createComponent(DialogComponent, {
        environmentInjector: this.injector
      });

      // Attach to application
      this.appRef.attachView(this.dialogComponentRef.hostView);

      // Append to body
      const domElem = this.dialogComponentRef.location.nativeElement;
      document.body.appendChild(domElem);
    }

    // Open the dialog and return its promise
    return this.dialogComponentRef.instance.open(config);
  }
}
